import { FieldHtmlNameUtil } from 'www-shared';
import UnifiedSignupScreenComponent from '../UnifiedSignupScreenComponent';
import AbstractSignupScreen from './AbstractSignupScreen';
import UnifiedSignupScreenName from '../UnifiedSignupScreenName';
import UnifiedSignupGradeLevel from '../session-info/UnifiedSignupGradeLevel';
import UnifiedSignupPlan from '../session-info/UnifiedSignupPlan';

export default class PersonaEduConvergeSignupScreen extends AbstractSignupScreen {
  public readonly screenName: UnifiedSignupScreenName = 'uss-persona-edu-converge';

  // eslint-disable-next-line class-methods-use-this
  public getVisibleComponents(): UnifiedSignupScreenComponent[] {
    return [];
  }

  public getValidatedComponents(): UnifiedSignupScreenComponent[] {
    return [
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.eduLevel),
      }),
    ];
  }

  public predicate(): boolean {
    const {
      gradeLevel, chosenPlan, persona,
    } = this.sessionInfo.value;

    if (gradeLevel) {
      return false;
    }

    if (!chosenPlan || !(chosenPlan.compareTo(UnifiedSignupPlan.edu) || chosenPlan.compareTo(UnifiedSignupPlan.educator))) {
      return false;
    }

    if (!persona || !persona.isEduPersona()) {
      return false;
    }

    return true;
  }

  // eslint-disable-next-line class-methods-use-this
  public async toNextScreen(): Promise<boolean> {
    const gradeLevel = this.getField(FieldHtmlNameUtil.eduLevel).val;
    this.sessionInfo.value.gradeLevel = UnifiedSignupGradeLevel.fromString(gradeLevel);
    return true;
  }

  public async initListeners({ partialDiv }: { partialDiv: HTMLDivElement }): Promise<void> {
    super.listenForFormInputs({
      partialDiv,
      fieldName: FieldHtmlNameUtil.eduLevel,
    });
  }

  // eslint-disable-next-line class-methods-use-this
  public getProgress(): number {
    return 55;
  }
}
